


export const COLORS = {
  primary: {
    lavender: "#14A896",     // Teal vif — couleur principale, boutons, CTA
    sky: "#7ECECA",          // Teal clair — accents, icônes secondaires
    blush: "#C2E8E8",        // Teal très pâle — backgrounds chips, badges doux
    main: "#0D6E6E",         // Teal nuit profond — header, titres forts
    red: "#E05C5C",          // Rouge sable doux — erreurs, suppression
  },
  secondary: {
    mint: "#0A9688",         // Teal moyen — succès, confirmations
    peach: "#F5A623",        // Ambre sable — alertes, badges "En attente", prix
    gold: "#E8B86D",         // Or sable clair — accents premium, étoiles, badges VIP
  },
  neutral: {
    white: "#FFFFFF",
    light: "#F0FAFA",        // Blanc teinté teal — fond page
    gray: "#8FA9A9",         // Gris-teal moyen — captions, placeholders
    dark: "#0D3D3D",         // Teal quasi-noir — texte body principal
    surface: "#E8F7F7",      // Teal très clair — fonds inputs, séparateurs
  },
};

export const GRADIENTS = {
  background: ["#FFFFFF", "#F0FAFA"],   // Blanc pur → teal pastel très clair
  primary: ["#0D6E6E", "#14A896"],      // Teal nuit → teal vif
  button: ["#14A896", "#0A9688"],       // Dégradé bouton teal lumineux
  card: ["#FFFFFF", "#F0FAFA"],         // Cartes blanc → blanc teal
};
